// This icon file is generated automatically.
var DownFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7 8a1 1 0 00-.77 1.64l5 6a1 1 0 001.54 0l5-6A1 1 0 0017 8H7z" } }] }, "name": "down", "theme": "filled" };
export default DownFilled;
